var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Facebook = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M11.7222 20V10.8889H14.7778L15.2222 7.33333H11.7222V5.05556C11.7222 4 12 3.33333 13.5 3.33333H15.3889V0.166667C15 0.111111 13.8889 0 12.6111 0C9.88889 0 8.05556 1.66667 8.05556 4.72222V7.33333H5V10.8889H8.05556V20H11.7222Z" }))); });
//# sourceMappingURL=Facebook.js.map